// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3mom9","large":"styles_large__v6vlQ"};